module.exports = __webpack_public_path__ + "static/media/fly0147.ac7cda25.webp";